import TextField from '@mui/material/TextField';
import type { TextFieldProps } from '@mui/material/TextField';

export type DateInputProps = Omit<
  TextFieldProps,
  'defaultValue' | 'inputProps' | 'onChange' | 'size' | 'slotProps' | 'type' | 'value' | 'variant'
> & {
  value: string | null;
  onChange: (value: string | null) => void;
};

/** Controlled calendar-date input that keeps native date handling out of page modules. */
export function DateInput({ value, onChange, ...props }: DateInputProps) {
  return (
    <TextField
      {...props}
      type="date"
      value={value ?? ''}
      variant="outlined"
      size="small"
      slotProps={{ inputLabel: { shrink: true } }}
      onChange={(event) => onChange(event.target.value || null)}
    />
  );
}
